import { type PropsWithChildren, useMemo, useState } from 'react';
import { Box } from '@mui/material';

import { JotSupportHostContext, useJotSupportHost } from './useJotSupportHost';

/** Shares the header portal target without placing DOM elements in Redux. */
export function JotSupportHostProvider({ children }: PropsWithChildren) {
  const [headerContainer, setHeaderContainer] = useState<HTMLDivElement | null>(null);
  const value = useMemo(() => ({ headerContainer, setHeaderContainer }), [headerContainer]);
  return <JotSupportHostContext.Provider value={value}>{children}</JotSupportHostContext.Provider>;
}

export function JotSupportHeaderSlot() {
  const host = useJotSupportHost();
  if (!host) return null;
  return (
    <Box
      ref={host.setHeaderContainer}
      data-jot-header-slot
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        '&:empty': { display: 'none' },
      }}
    />
  );
}
